/**
 * The sentence each kind of failure gets — what happened and what to do (I-0396, I-0398).
 *
 * No imports, on purpose: `ApiService.httpErrorMessage`, `loadFailure` and `actionFailure` all say
 * these, and `loadFailure` already imports `ApiService`, so the words live where none of them has to
 * import another.
 */
export const FAILURE_REASONS = {
  offline: 'FEATit could not be reached. Check your connection, then try again.',
  // I-1829: a stall happens while the connection is fine (the request was sent, others answer), so
  // it names the slow server; "Check your connection" is the offline sentence's alone.
  stalled: 'The server is taking too long to answer. Try again in a moment.',
  // I-2083: the server answered that it ran out of time, so it is neither unreachable nor unexpected.
  serverTimeout:
    'The server stopped this because it took too long. Try again in a moment, or ask for less.',
  server:
    'The server ran into an error. Try again; if it keeps happening, tell whoever runs this FEATit deployment.',
  // I-1917: the address this app sends to answered, but not as FEATit's API does.
  unreadableAnswer:
    "The server's answer could not be read: this app may be sending to an address that isn't FEATit's. Try again; if it keeps happening, tell whoever runs this FEATit deployment.",
  unknown: 'Something unexpected went wrong. Try again.',
  permissionUnnamed: "You don't have permission to see this. A System Admin can grant access.",
} as const;

export function permissionReason(permission: string): string {
  return `You don't have permission to see this. It needs "${permission}" — a System Admin can grant it.`;
}

/** Nest's default exception texts, which name a status rather than a reason for the reader. */
export const GENERIC_SERVER_TEXTS: ReadonlySet<string> = new Set([
  'internal server error',
  'forbidden resource',
  'forbidden',
  'unauthorized',
  'bad request',
  'bad request exception',
  'not found',
  'service unavailable',
]);

export function isGenericServerText(text: string): boolean {
  return GENERIC_SERVER_TEXTS.has(text.trim().toLowerCase());
}
